// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"21fe2df6","278":"7afbc9aa","372":"71b7d16c","541":"b7c66338","787":"82f2ae70","815":"8f8838b2","849":"7a05e3a7","856":"3a439834"}[chunkId] + ".chunk.js";
};